import { t as useTheme$1, p as THEME_ID, q as defaultTheme } from './injectIntl-6b03af4d.js';

function useTheme() {
  const theme = useTheme$1(defaultTheme);
  return theme[THEME_ID] || theme;
}

export { useTheme as u };

//# sourceMappingURL=useTheme-fbd8978e.js.map